import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\testimonials\\TestimonialsCarousel.tsx");
